import { useFormikContext } from 'formik'
import React, { useState } from 'react'
import CardElement from '../../components/card.v2'
import InputElement from '../../components/InputElement'
import TextAreaElement from '../../components/TextArea'
import { HoverBorderGradientDemo } from '../../components/Button'
import { useNavigate } from 'react-router-dom'

const Faq = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const navigate = useNavigate()
  const [faqs, setFaqs] = useState(
    values.faq && values.faq.length > 0
      ? values.faq
      : [{ question: '', answer: '' }]
  )

  const handleInputChange = (index, field, value) => {
    const updatedFaqs = [...faqs]
    updatedFaqs[index][field] = value
    setFaqs(updatedFaqs)
  }

  const addFaq = () => {
    setFaqs([...faqs, { question: '', answer: '' }])
  }

  const removeFaq = (index) => {
    const updatedFaqs = faqs.filter((_, i) => i !== index)
    setFaqs(updatedFaqs)
  }

  console.log('faqs', faqs)
  return (
    <div className='max-w-xl mx-auto'>
      <CardElement className={'w-full'}>
        <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
          <svg
            onClick={() => {
              setCurrentStep(currentStep - 1)
            }}
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='2'
            stroke='currentColor'
            className='w-5 h-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M15 19l-7-7 7-7'
            />
          </svg>
        </h2>
        <div className='max-h-[170px] md:max-h-[calc(100vh-400px)] h-auto overflow-auto custom-scrollbar px-6'>
          <div>
            <div className='flex flex-row justify-between items-start sticky top-0 bg-white'>
              <div className=''>
                <h2 className='text-xl font-medium text-gray-700 mb-1'>FAQ</h2>
                <p className='text-gray-600 text-sm font-medium mt-2 mb-4'>
                  List common questions clients ask and provide responses
                </p>
              </div>
              <button
                type='button'
                onClick={addFaq}
                className='w-12 h-12 flex justify-center items-center flex-col text-sm text-white bg-blue-500 hover:bg-blue-700 rounded-md'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='2'
                  stroke='currentColor'
                  className='w-5 h-5'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M12 4v16m8-8H4'
                  />
                </svg>
              </button>
            </div>

            <div className=''>
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={
                    index === faqs.length - 1
                      ? 'pt-6 pb-6'
                      : 'pt-6 pb-6 border-b border-b-gray-600'
                  }
                >
                  <button
                    type='button'
                    onClick={() => removeFaq(index)}
                    className='mt-2 float-right pb-3 text-sm text-red-500 hover:text-red-700'
                  >
                    Remove
                  </button>
                  <InputElement
                    label={`0${index + 1}. Question`}
                    type='text'
                    name={`question-${index}`}
                    value={faq.question}
                    handleInputChange={(e) =>
                      handleInputChange(index, 'question', e.target.value)
                    }
                    placeholder='Your question here'
                  />
                  <TextAreaElement
                    label={`0${index + 1}. Answer`}
                    type='text'
                    name={`answer-${index}`}
                    value={faq.answer}
                    handleInputChange={(e) =>
                      handleInputChange(index, 'answer', e.target.value)
                    }
                    placeholder='Your answer here'
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='md:col-span-2 md:flex md:justify-end sticky bottom-0'>
          <div className='mt-8'>
            <HoverBorderGradientDemo
              type='button'
              onClick={() => {
                setFieldValue('faq', faqs)
                navigate('./demo', { state: values })
              }}
            >
              <span className='font-bold capitalize px-12'>Next</span>
            </HoverBorderGradientDemo>
          </div>
        </div>
      </CardElement>
    </div>
  )
}

export default Faq
